import { createAction } from '@reduxjs/toolkit';
export const comptrollerInfoFetched = createAction('comptroller/infoFetched');
